import React, { FC } from 'react';
import { AppUserRatingsFilters } from '../models/appUserRatingsModels';
import { ChipModel } from 'shared/components/filters/Chip';
import FilterChipsBar from 'shared/components/filters/FilterChipsBar';
import { useDriverNames } from 'shared/hooks/useDriverNames';
import { useClientNames } from 'shared/hooks/useClientNames';

interface Props {
  filters: AppUserRatingsFilters;
  defaultFilters: AppUserRatingsFilters;
  onFiltersChange: (filters: AppUserRatingsFilters) => void;
}

const AppUserRatingsChipsBar: FC<Props> = ({ filters, defaultFilters, onFiltersChange }) => {
  const { getDriverName } = useDriverNames();
  const { getClientName } = useClientNames();
  const chips: ChipModel[] = [];

  const CLIENT_TYPE_LABELS: Record<string, string> = {
    BusinessClient: 'Empresa',
    ParticularClient: 'Particular'
  };

  if (filters.dateFrom && filters.dateFrom.format('DD/MM/YYYY') !== defaultFilters?.dateFrom?.format('DD/MM/YYYY')) {
    chips.push({
      label: 'Desde:',
      value: filters.dateFrom.format('DD/MM/YYYY'),
      onDelete: () => onFiltersChange({ ...filters, dateFrom: null })
    });
  }

  if (filters.dateTo && filters.dateTo.format('DD/MM/YYYY') !== defaultFilters?.dateTo?.format('DD/MM/YYYY')) {
    chips.push({
      label: 'Hasta:',
      value: filters.dateTo.format('DD/MM/YYYY'),
      onDelete: () => onFiltersChange({ ...filters, dateTo: null })
    });
  }

  if (filters.transfer_reservation_id != null) {
    chips.push({
      label: 'Reserva #:',
      value: `${filters.transfer_reservation_id}`,
      onDelete: () => onFiltersChange({ ...filters, transfer_reservation_id: null })
    });
  }

  if (filters.client_type && filters.client_type !== 'AllClient') {
    chips.push({
      label: 'Tipo cliente:',
      value: CLIENT_TYPE_LABELS[filters.client_type],
      onDelete: () => onFiltersChange({ ...filters, client_type: 'AllClient', client_id: null })
    });
  }

  if (filters.client_id != null) {
    chips.push({
      label: 'Cliente:',
      value: getClientName(filters.client_id, filters.client_type),
      onDelete: () => onFiltersChange({ ...filters, client_id: null })
    });
  }

  if (filters.driver_id != null) {
    chips.push({
      label: 'Chofer:',
      value: getDriverName(filters.driver_id),
      onDelete: () => onFiltersChange({ ...filters, driver_id: null })
    });
  }

  if (filters.score_min != null) {
    chips.push({
      label: 'Cal. mín:',
      value: `${filters.score_min}`,
      onDelete: () => onFiltersChange({ ...filters, score_min: null })
    });
  }

  if (filters.score_max != null) {
    chips.push({
      label: 'Cal. máx:',
      value: `${filters.score_max}`,
      onDelete: () => onFiltersChange({ ...filters, score_max: null })
    });
  }

  return <FilterChipsBar chips={chips} />;
};

export default AppUserRatingsChipsBar;
